<template>
  <div>
    <h1>Promotions</h1>
    <v-btn :to="{name:'promotionAdd'}">
      <v-icon>add</v-icon>Promotion
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="modifiedPromotions"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn small :to="{name:'promotion', params:{id: props.item.id}}">{{ props.item.id }}</v-btn>
          </td>
          <td>
            <span v-if="!props.item.referrer">No referrer found</span>
            <EntityZ :entity="props.item.referrer" v-if="props.item.referrer" />
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.body }}</td>
          <td>
            <router-link
              :to="{name:'leadScriptApi', params:{id:props.item.leadscriptapiid}}"
              v-if="props.item.leadScriptApi"
            >{{ `${props.item.leadscriptapiid} ${props.item.leadScriptApi.name}` }}</router-link>
          </td>
          <td>{{ props.item.startdate | formatDate }}</td>
          <td>{{ props.item.enddate | formatDate }}</td>
          <td>{{ props.item.pauseAutoProcessing }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Promotions",
  metaInfo() {
    return {
      title: "Promotions",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EntityZ
  },
  computed: {
    modifiedPromotions() {
      if (!this.promotions) {
        return undefined;
      }
      const leadScriptApisMap = this.leadScriptApis
        ? convertListOfObjectsToMap(this.leadScriptApis, "id")
        : undefined;
      const referrersMap = this.referrers
        ? convertListOfObjectsToMap(this.referrers, "id")
        : undefined;
      return this.promotions.map(p => {
        const leadScriptApi =
          leadScriptApisMap && leadScriptApisMap[p.leadscriptapiid]
            ? leadScriptApisMap[p.leadscriptapiid]
            : undefined;
        const referrer =
          referrersMap && referrersMap[p.entityid]
            ? referrersMap[p.entityid]
            : undefined;
        return { ...p, leadScriptApi, referrer };
      });
    }
  },
  data() {
    return {
      promotions: null,
      leadScriptApis: null,
      referrers: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Referrer",
          value: "referrer.name"
        },
        {
          text: "Code",
          value: "code"
        },
        {
          text: "Description",
          value: "body"
        },
        {
          text: "Lead script api",
          value: "leadScriptApi.name"
        },
        {
          text: "Start date",
          value: "startdate"
        },
        {
          text: "End date",
          value: "enddate"
        },
        {
          text: "Pause auto processing",
          value: "pauseAutoProcessing"
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchPromotions() {
      nbmlaw
        .get(`/cors/admin/sales/promotions`)
        .then(response => {
          // console.log(response.data);
          this.promotions = response.data;
        })
        .catch(() => {});
    },
    fetchLeadScriptApis() {
      nbmlaw
        .get(`/cors/admin/sales/leadScriptApis`)
        .then(response => {
          // console.log(response.data);
          this.leadScriptApis = response.data;
        })
        .catch(() => {});
    },
    fetchReferrers() {
      nbmlaw
        .get(`/cors/admin/directory/types/13/entities`)
        .then(response => {
          // console.log(response.data);
          this.referrers = response.data;
        })
        .catch(() => {});
    }
  },
  created() {
    this.fetchPromotions();
    this.fetchLeadScriptApis();
    this.fetchReferrers();
  }
};
</script>